function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#231F20",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 24C5.4 24 0 18.6 0 12S5.4 0 12 0s12 5.4 12 12-5.4 12-12 12zm0-20.9c-4.9 0-8.9 4-8.9 8.9s4 8.9 8.9 8.9 8.9-4 8.9-8.9-4-8.9-8.9-8.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.2 10.1h-.4c-.4 0-.8.3-.8.8v5.8c0 .4.3.8.8.8h.4c.4 0 .8-.3.8-.8v-5.8c0-.5-.4-.8-.8-.8zM12 8.9c.3 0 .6-.1.9-.3.2-.2.4-.5.4-.8 0-.3-.1-.6-.4-.8-.2-.2-.5-.3-.9-.3-.3 0-.6.1-.9.3-.2.2-.3.5-.3.8 0 .3.1.6.3.8.3.1.5.3.9.3z"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgComponent;